const removeDuplicates = <T>(list: T[]) =>
  list?.filter((elm, pos, arr) => arr.indexOf(elm) === pos) || [];

const removeDuplicatesByKey = <T>(list: T[], key: keyof T) =>
  list?.filter((v, i, a) => a.findIndex((t) => t[key] === v[key]) === i) || [];

export { removeDuplicates, removeDuplicatesByKey };
